
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["obfuscateCode","applyTransformations","preObfuscationAnalysis"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "d9681b92acea25a76cef.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "d9681b92acea25a76cef.worker.js");
					addMethods(w, methods)
					
					return w
				}
			